import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import { Callback } from './Callback';
import { Logout } from './Logout';
import { LogoutCallback } from './LogoutCallback';
import { SilentRenew } from './SilentRenew';
import { SigninRedirect } from './SigninRedirect';

const AuthRoutes = (props: {
  ready: boolean;
  loginText: string;
  waitText: string;
  logoutText: string;
  tryLogin: string;
}) => {
  return (
    <Routes>
      <Route
        path="/auth/signin-oidc"
        element={
          <Callback
            loginText={props.ready ? props.loginText : ''}
            waitText={props.ready ? props.waitText : ''}
          />
        }
      />
      <Route
        path="/auth/logout"
        element={
          <Logout logoutText={props.logoutText} waitText={props.waitText} />
        }
      />
      <Route path="/auth/logout/callback" element={<LogoutCallback />} />
      <Route path="/auth/silentrenew" element={<SilentRenew />} />
      <Route
        path="/auth/signin-redirect"
        element={
          <SigninRedirect tryLogin={props.tryLogin} waitText={props.waitText} />
        }
      />
      <Route path="*" element={null} />
    </Routes>
  );
};

export default AuthRoutes;
